import React, {useMemo} from 'react';
import {sortChampData} from "../../../function";

const UseMvp = ({match,myMatch}) => {

    const getMvp = useMemo(() => {
        if (Array.isArray(match?.participants_list)) {
            const filteredTeam = match?.participants_list.filter((data) => data.side === myMatch.side);
            const sorted = sortChampData(filteredTeam, [{value: "ai_score", sortType: false}]);
            const index = sorted.findIndex((data) => data.puu_id === myMatch.puu_id);
            return index === 0;
        }
    }, [match, myMatch]);

    return {
        getMvp
    }
};

export default UseMvp;